module.exports = __webpack_public_path__ + "img/invite.f2ab4c49.gif";